var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderDetailBottomArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91274 7.53042L0.874719 3.46086C0.382909 2.9652 0.273158 2.39807 0.545465 1.75947C0.816738 1.11981 1.30182 0.799988 2.00071 0.799988H9.9991C10.698 0.799988 11.1831 1.11981 11.4543 1.75947C11.7266 2.39807 11.6169 2.9652 11.1251 3.46086L7.08706 7.53042C6.93175 7.68694 6.7635 7.80433 6.58231 7.8826C6.40112 7.96086 6.20698 7.99999 5.9999 7.99999C5.79282 7.99999 5.59869 7.96086 5.4175 7.8826C5.2363 7.80433 5.06805 7.68694 4.91274 7.53042Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDetailBottomArrow);
export default __webpack_public_path__ + "static/media/order-detail-bottom-arrow.9815c9e40a4383f664aafaeae20fd528.svg";
export { ForwardRef as ReactComponent };